<template>
<v-footer
      color="#2f363e"
      padless
      class="pt-4"
    >
    <v-row
        justify="center"
        no-gutters
      >
      <v-btn

          color="white"
          text
          to="/"
          rounded
          class="my-2"
        >
         Inicio
        </v-btn>
      <v-btn

          color="white"
          text
          to="/politicas"
          rounded
          class="my-2"
      >
        Politicas de Privacidad
      </v-btn>
<v-tooltip top>
  <template v-slot:activator="{ on, attrs }">
      <v-avatar
          v-bind="attrs"
          v-on="on"
          @click="$router.push({name:'logpuerta'})"
          color="#6D9886"

      >
        <img src="@/assets/icons/backstage.png" />
      </v-avatar>
  </template>
  <span>Accede a la lectura de Puerta para tu evento</span>
</v-tooltip>
      <v-btn

          color="white"
          text
          to="/terminos"
          rounded
          class="my-2"
      >
        Términos y Condiciones
      </v-btn>
        <v-col
          class=" lighten-2 py-4 text-center white--text"
          cols="12"
        >
          {{ new Date().getFullYear() }} — <strong>Tunay</strong>
        </v-col>
    </v-row>
  <cookie-law buttonText="Acepto">
    <div slot="message">
      Las cookies de este sitio web se usan para personalizar el contenido y los anuncios, ofrecer funciones de redes sociales y analizar el tráfico. Además, compartimos información sobre el uso que haga el sitio web con nuestros partners de redes sociales, publicidad y análisis web, quienes pueden combinarla con otra información que les haya proporcionado o que hayan recopilado a partir del uso que haya hecho de sus servicios
    </div>
  </cookie-law>
</v-footer>
</template>
<script>
import CookieLaw from 'vue-cookie-law'
import {mapGetters} from "vuex";

  export default {
    name: 'piepagina',
    components: {
      CookieLaw
    },
    data () {
      return {
    conectad:false
  }},
watch: {
  '$store.state.usuario': function() {
    if (this.usuario  === null){
      this.conectad = false
    }else{
      this.conectad = true
    }
  }
},
    mounted() {
      if (this.usuario  === null){
        this.conectad = false
      }else{
        this.conectad = true
      }

    },
    computed: {
  // map `this.user` to `this.$store.getters.user`
...mapGetters({
    conectado: "conectado",
    usuario: "usuario"
  })
}}

</script>
